import { createSelector, createStructuredSelector } from "reselect";
import { selectUserInfo, selectUserName } from "scenes/selectors";
import { initialState, State as EditUsernameState } from "./redux";

/**
 * Direct selector to the editUsername state domain
 */

const selectEditUsernameDomain: (any) => EditUsernameState = (state) =>
  state.editUsername || initialState;

/**
 * Custom selectors to the editUsername state
 */
export const selectEditUsername = createSelector(
  selectEditUsernameDomain,
  (substate) => substate
);

/**
 * Multi instance selectors exporting a factory
 */
export const makeSelectEditUsername = () =>
  createSelector(selectEditUsernameDomain, (substate) => substate);

export const selectUsernameUpdateErrorType = createSelector(
  selectEditUsernameDomain,
  (substate) => substate.usernameUpdateErrorType
);

export const selectSubmittingUsernameUpdate = createSelector(
  selectEditUsernameDomain,
  (substate) => substate.submittingUsernameUpdate
);

export default createStructuredSelector({
  userInfo: selectUserInfo,
  userName: selectUserName,
  usernameUpdateErrorType: selectUsernameUpdateErrorType,
  submittingUsernameUpdate: selectSubmittingUsernameUpdate,
});
